const dataLayer = window.dataLayer || [];

const gtmEvents = {
  bulkActivationCsvUploaded: 'bulkActivationCsvUploaded',
};

export default function DeviceActivationsBulkController(
  $scope,
  $timeout,
  $q,
  $rootScope,
  installationsService,
  transfersService,
  packagesService,
  usersService,
  gettextCatalog,
  securityGroupsService,
) {
  'ngInject';

  const vm = this;

  vm.pendingRows = [];
  vm.showSubmitSpinner = false;
  vm.progress = 0;
  vm.packages = new Array();
  vm.canTransfer = false;
  vm.securityGroups = [];
  vm.selectedModules = []; // ceate an array to hold the modules selected in the dropdown list
  vm.selectedPackageModules = []; // container to hold the modules from the selected package in the dropdown
  vm.package = null;
  vm.isSecurityGroupOptional = false;

  let currentRow = null;
  let lastActivationId = null;
  const modules = new Array();

  vm.fileNameChanged = fileNameChanged;
  vm.preventFormSubmit = preventFormSubmit;
  vm.selectedItemChanged = selectedItemChanged;
  vm.changeSelectedPackage = changeSelectedPackage;
  vm.addModuleToPackages = addModuleToPackages;
  vm.removeModuleFromPackages = removeModuleFromPackages;
  vm.getSuccessfulRows = getSuccessfulRows;
  vm.getNumProcessedRows = getNumProcessedRows;
  vm.getNumRowsWithError = getNumRowsWithError;
  vm.getRowsWithError = getRowsWithError;

  init();

  function init() {
    packagesService
      .getAllPackages()
      .then(
        function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const pkg = response.data[i];
            if (!pkg.inactive && pkg.tags) {
              if (pkg.isModule) {
                modules.push({
                  name: pkg.name,
                  id: pkg.id,
                });
              } else {
                vm.packages.push(pkg);
              }
            }
          }
          for (let j = 0; j < $rootScope.currentUser.features.length; j++) {
            if ($rootScope.currentUser.features[j].path === 'devices.transfer') {
              vm.canTransfer = true;
              return transfersService.getTransferKeys().then(null, function (error) {
                let errorMsg = gettextCatalog.getString(
                  'An error occurred while retrieving transfer keys',
                );
                if (error.data || error.status) {
                  if (error.data.message) {
                    errorMsg = `${
                      error.data.message
                    } ${error.status.toString()} - ${error.statusText.toString()}`;
                  } else {
                    errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
                  }
                } else {
                  errorMsg += gettextCatalog.getString('. Please try again later.');
                }
                vm.transferErrorFlag = true;
                vm.transferErrorText = errorMsg;
                vm.loading = false;
                return $q.reject();
              });
            }
          }
        },
        function (error) {
          let errorMsg = gettextCatalog.getString(
            'Error retrieving installation packages from the i3 API ',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = `${
                error.data.message
              } ${error.status.toString()} - ${error.statusText.toString()}`;
            } else {
              errorMsg += `: ' + ${error.status.toString()} - ${error.statusText.toString()}`;
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          vm.onLoadErrorFlag = true;
          vm.onLoadErrorText = errorMsg;
          vm.loading = false;
          return $q.reject();
        },
      )
      .then(function (response) {
        vm.transferKeys = !response ? [] : response.data.transferKeys || [];
      });
    getAllSecurityGroups();
  }

  function fileNameChanged(ele) {
    const { files } = ele;
    const l = files.length;
    const namesArr = [];
    if (files.length > 0) vm.csvFileError = false;
    for (let i = 0; i < l; i++) {
      namesArr.push(files[i].name);
    }
  }

  function preventFormSubmit(bulkActivateForm) {
    vm.bulkActivateForm.$setSubmitted();
    if (bulkActivateForm.$invalid) {
      vm.loading = false;
      vm.showSubmitSpinner = false;
      event.preventDefault();
    } else {
      vm.showSubmitSpinner = true;
    }
  }

  function getAllSecurityGroups() {
    if ($rootScope.currentUser.securityMode.toLowerCase() === 'open') {
      securityGroupsService.getAllSecurityGroups().then(
        (response) => {
          vm.securityGroups = response.data.data;
          vm.hasSecurityGroups = vm.securityGroups.length >= 1; // show dropdown
          vm.isSecurityGroupOptional = true;
        },
        () => {
          vm.onLoadErrorFlag = true;
          vm.onLoadErrorText = gettextCatalog.getString(
            'Security group information could not be retrieved.',
          );
        },
      );
    } else {
      usersService.getUser($rootScope.currentUser.id).then(
        function (response) {
          vm.securityGroups = response.data.groups.data;
          vm.securityMode = response.data.securityMode;
          // security group option selector is hidden under the following circumstances, so the default and the only one security group has to be assigned to the selection model
          if (vm.securityGroups.length === 1 && vm.securityMode.toLowerCase() === 'discretionary')
            vm.securityGroup = vm.securityGroups[0];
          vm.hasSecurityGroups = vm.securityGroups.length >= 1; // show dropdown
          vm.isSecurityGroupOptional = false;
        },
        () => {
          vm.onLoadErrorFlag = true;
          vm.onLoadErrorText = gettextCatalog.getString(
            'Security group information could not be retrieved.',
          );
        },
      );
    }
  }

  function changeSelectedPackage(selectedPackage) {
    vm.package = selectedPackage;
    vm.selectedItemChanged();
  }

  // selectedItemChanged() will traverse the modules[] and the packages.modules[], compare the modules list in
  // both result sets and determine wether or not the selectedPackage has compatible modules to display to the user.
  function selectedItemChanged() {
    vm.selectedPackageModules = [];
    vm.selectedModules = [];
    if (vm.package.modules.length >= 1) {
      modules.forEach((gm) => {
        vm.package.modules.forEach((pm) => {
          if (gm.id === pm) {
            vm.selectedPackageModules.push(gm);
          }
        });
      });
    }
    // set hide or show the modules dropdown
    if (vm.selectedPackageModules.length > 0) {
      vm.hasModulespkg = true;
    } else {
      // We need to remove the existing values from the model and selectedPackageModules when hasModules is false.
      vm.hasModulespkg = false;
      vm.selectedPackageModules = new Array();
    }
  }

  function addModuleToPackages(module) {
    vm.selectedModules.push(module);
  }

  function removeModuleFromPackages(module) {
    const idx = vm.selectedModules.indexOf(module);
    vm.selectedModules.splice(idx, 1);
  }

  $scope.$on('CsvFileUploaded', function (evt, args) {
    const { fatalError, rows } = args;
    vm.showSubmitSpinner = false;
    vm.inProgress = true;
    $scope.$digest();
    vm.currentStatus = gettextCatalog.getString('Processing...');

    if (fatalError) {
      vm.csvFileError = vm.currentStatus = fatalError;
      vm.inProgress = false;
      return;
    }
    if (rows.length === 0) {
      vm.csvFileError = vm.currentStatus = gettextCatalog.getString(
        'Invalid CSV file. Please check and try again.',
      );
      vm.inProgress = false;
      return;
    }

    vm.showSummaryReport = true;
    vm.rows = rows;
    vm.pendingRows = []; // Add all of the rows in the csv that passed csv formatting validation without errors

    dataLayer.push({
      event: gtmEvents.bulkActivationCsvUploaded,
      data: {
        rows: rows.length,
        fatalError,
      },
    });

    for (let i = 0; i < vm.rows.length; i++) {
      const currentRow = vm.rows[i];
      if (!currentRow.Error) {
        currentRow._validFormat = true;
        vm.pendingRows.push(currentRow);
      } else {
        currentRow._processed = true;
      }
    }
    activateNextRow(); // Start activating the rows
  });

  function getSuccessfulRows() {
    if (!vm.rows) return [];
    let result = 0;
    for (let i = 0; i < vm.rows.length; i++) {
      if (vm.rows[i]._success) result++;
    }
    return result;
  }

  function getNumProcessedRows() {
    if (!vm.rows) return [];
    let result = 0;
    for (let i = 0; i < vm.rows.length; i++) {
      if (vm.rows[i]._processed) result++;
    }
    return result;
  }

  function getNumRowsWithError() {
    return vm.getRowsWithError().length;
  }

  function getRowsWithError() {
    const result = [];
    if (!vm.rows) return [];
    for (let i = 0; i < vm.rows.length; i++) {
      if (vm.rows[i].Error) result.push(vm.rows[i]);
    }
    return result;
  }

  function onActivateSuccess(response) {
    lastActivationId = response.data.href.match(/(\d+)$/)[1]; // Set the id of the last activation so that we can rollback in case the installation fails
    if (vm.transferKey) {
      vm.currentStatus = gettextCatalog.getString(
        'Transferring ownership of device {{deviceSerial}}',
        {
          deviceSerial: currentRow.DeviceSerialNumber,
        },
      );
      const resources = [response.data.href];
      return transfersService.transferResources(vm.transferKey, resources);
    }
    vm.currentStatus = gettextCatalog.getString('Device {{deviceSerial}} activated with success', {
      deviceSerial: currentRow.DeviceSerialNumber,
    });
    currentRow._success = true;
    $timeout(activateNextRow(), 100);
  }

  function onActivateFailed(error) {
    currentRow.Error = gettextCatalog.getString('Error activating device. HTTP {{error}}', {
      error: error.status,
    });
    vm.currentStatus = gettextCatalog.getString('Failure activating device {{deviceSerial}}', {
      deviceSerial: currentRow.DeviceSerialNumber,
    });
    if (error.data) currentRow.Error += `: ${error.data.Message ? error.data.Message : error.data}`;
    $timeout(activateNextRow(), 250);
  }

  function onTransferSuccess(response) {
    if (!response) return;
    currentRow._success = true;
    vm.currentStatus = gettextCatalog.getString(
      'Transferred device {{deviceSerial}} with success',
      {
        deviceSerial: currentRow.DeviceSerialNumber,
      },
    );
    $timeout(activateNextRow(), 100);
  }

  function onTransferFailed() {
    if (!lastActivationId) return; // If there was no activation id, we should not have gotten to this point.
    installationsService
      .deleteInstallation(lastActivationId) // delete the installation if transfer fails (poor man's transaction)
      .then(
        function (response) {
          currentRow.Error = gettextCatalog.getString(
            'Error transferring ownership. HTTP {{status}}',
            {
              status: response.status,
            },
          );
          vm.currentStatus = gettextCatalog.getString(
            'Failure transferring device {{deviceSerial}}',
            {
              deviceSerial: currentRow.DeviceSerialNumber,
            },
          );
          if (response.data)
            currentRow.Error += `: ${
              response.data.message ? response.data.message : response.data
            }`;

          $timeout(activateNextRow(), 250);
        },
        function (error) {
          currentRow.Error = gettextCatalog.getString(
            'The device has been activated but the ownership could not be transferred. Please contact support. HTTP {{status}}',
            {
              status: error.status,
            },
          );
          vm.currentStatus = gettextCatalog.getString(
            'Failure transferring device {{deviceSerial}}',
            {
              deviceSerial: currentRow.DeviceSerialNumber,
            },
          );
          if (error.data)
            currentRow.Error += `: ${error.data.message ? error.data.message : error.data}`;

          $timeout(activateNextRow(), 250);
        },
      );
  }

  function activateNextRow() {
    vm.progress = (vm.getNumProcessedRows() * 100) / vm.rows.length;

    if (!vm.securityGroup && !vm.isSecurityGroupOptional) {
      vm.showSummaryReport = false;
      vm.inProgress = false;
      return;
    }

    const packagesIDs = new Array();
    packagesIDs.push({
      id: vm.package.id,
    });
    if (vm.selectedModules) {
      for (let i = 0; i !== vm.selectedModules.length; i++) {
        packagesIDs.push({
          id: vm.selectedModules[i].id,
        });
      }
    }

    if (vm.pendingRows.length === 0) {
      // If there are no rows left, then mark the process as finished...
      vm.inProgress = false; // finished
      const errorRows = vm.getRowsWithError();
      vm.currentStatus =
        errorRows.length > 0
          ? gettextCatalog.getString(
              'The process completed with one or more failures. Review the details below and click on the button to download a report in CSV format.',
            )
          : gettextCatalog.getString('The process completed successfully.');
      return;
    }

    currentRow = vm.pendingRows[0];
    currentRow._processed = true;
    lastActivationId = null; // clear the last activation id
    vm.pendingRows.splice(0, 1); // Pop the last row from the pending rows
    vm.currentStatus = gettextCatalog.getString('Activating device {{deviceSerial}}', {
      deviceSerial: currentRow.DeviceSerialNumber,
    });

    // If there was a formatting error with the current row...do not activate, and show it in the error log NOTE: This shouldn't happen because we are filering out the rows with invalid csv foramtting from pending activations
    if (currentRow.Error) {
      $timeout(activateNextRow(), 250);
    } else {
      const sgResource = vm.securityGroup ? vm.securityGroup.href : '';
      const newInstallation = {
        device: {
          serialNumber: currentRow.DeviceSerialNumber,
        },
        equipment: {
          name: currentRow.DeviceSerialNumber,
          attrs: {
            make: currentRow.EquipmentMake,
            model: currentRow.EquipmentModel,
            'model year': currentRow.EquipmentModelYear,
            vin: currentRow.EquipmentVin,
          },
        },
        packages: packagesIDs,
      };

      // Create an installation object with the current row.
      installationsService
        .createInstallation(newInstallation, sgResource)
        .then(onActivateSuccess, onActivateFailed) // On activation success, transfer if necessary...
        .then(onTransferSuccess, onTransferFailed); // On transfer failure...rollback the activation
    }
  }
}
